import { prodAxoDomainName, prodDomainName } from './prodDomainName.mjs'

export const prodHostname = `app.${prodDomainName}`
export const isAxoProdHostname = `app.${prodAxoDomainName}`
